import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import {
    generatePath,
    useHistory,
    useParams,
    useRouteMatch,
} from 'react-router-dom';
import { List } from 'immutable';
import {
    fetchQueueCalendar,
    updateQueueOpeningHours,
} from 'flow/actions/pbx-actions';
import CalendarBase from 'flow/components/calendar/CalendarBase';
import Loading from 'flow/components/ui-components/Loading';
import { QueueKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';

import { getCalendarWithActiveProfileAddedToEvents } from 'flow/utils/calendar-utils';
import { sortProfilesAfterPlusId } from 'flow/utils/profile-utils';

const PbxQueueCalendar = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { entityKey } = useParams<{ entityKey: QueueKey }>();
    const match = useRouteMatch();

    const profiles = useAppSelector((state) =>
        state.pbx.getIn(['queues', entityKey, 'profiles'], List()),
    );

    const activeProfile = useAppSelector((state) =>
        state.pbx.getIn(['queues', entityKey, 'activeProfile'], null),
    );

    const calendar = useAppSelector((state) =>
        state.pbx.getIn(['queues', entityKey, 'calendar']),
    );

    useEffect(() => {
        dispatch(fetchQueueCalendar(entityKey));
    }, []);

    if (!calendar || !profiles) {
        return <Loading signalFinishedLoading={true} />;
    }

    const onClickBack = () => {
        if (
            [routes['pbx.queues.entityKey.settings.calendar']].includes(
                match.path,
            )
        ) {
            history.push(
                generatePath(routes['pbx.queues.entityKey.settings'], {
                    entityKey,
                }),
            );
        } else {
            history.push(
                generatePath(routes['pbx.queues.entityKey.profiles'], {
                    entityKey,
                }),
            );
        }
    };

    return (
        <CalendarBase
            calendar={getCalendarWithActiveProfileAddedToEvents(
                activeProfile,
                calendar,
            )}
            entityKey={entityKey}
            profiles={sortProfilesAfterPlusId(profiles)}
            onClickBack={onClickBack}
            updateOpeningHours={(openingHours) => {
                dispatch(updateQueueOpeningHours(entityKey, openingHours));
            }}
        />
    );
};

export default PbxQueueCalendar;
